import React from 'react';
import { FormattedMessage } from 'react-intl';
import SystemFlagWrapper from './SystemFlagWrapper';

const SystemFlag = ({
  className = '',
  flush,
  messageId = 'fair.system',
  messageText = null,
  solid = false,
}) => (
  <SystemFlagWrapper flush={flush} className={className} solid={solid}>
    {messageId && !messageText && <FormattedMessage id={messageId} />}
    { messageText }
  </SystemFlagWrapper>
);

export default SystemFlag;
